import { ContentSection } from '@cinch-labs/design-system'
import {
  getStoryblokImageServiceUrl,
  type StoryBlokRichText,
  type StoryblokImage,
} from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import cx from 'classnames'

import styles from './text-inline-image.module.css'

export interface TextInlineImageProps {
  body: StoryBlokRichText
  image: StoryblokImage
  imagePosition?: 'left' | 'right'
}

export const TextInlineImage: React.FC<TextInlineImageProps> = ({
  body,
  image,
  imagePosition = 'right',
}) => (
  <div
    className={cx(styles.wrapper, {
      [styles.imageLeft]: imagePosition === 'left',
    })}
    data-testid="text-inline-image-container"
  >
    <div className={styles.imageWrapper}>
      <img
        src={getStoryblokImageServiceUrl(image.filename, {
          width: 900,
          filters: [{ quality: 60 }],
        })}
        className={styles.image}
        alt={image.alt ?? undefined}
      />
    </div>

    <ContentSection
      classNames={{
        body: 'storyblokRichTextBody',
      }}
    >
      {renderWithResolver(body)}
    </ContentSection>
  </div>
)
